export default __webpack_public_path__ + "static/media/usaFlag.dea7d108.svg";